import { MachineState, TagRecord } from './states.models'

export enum ComputedState {
  loading = 'loading',
  stable = 'stable',
  error = 'error',
}

export enum ComputedStatus {
  conflict = 'conflict',
  warning = 'warning',
}

export enum ComputedPairingStatus {
  conflict = 'conflict',
}

export interface ComputedRecord {
  record: TagRecord
  computedState: ComputedState
  computedStatus?: ComputedStatus
  computedStatusMessage?: string
  computedPairingStatus?: ComputedPairingStatus
  computedPairingStatusMessage?: string
}

export interface ComputedData {
  suggestion: ComputedRecord[]
  selection: ComputedRecord[]
  warningList?: string[]
  pairingWarningList?: string[]
  firstPairingValuesList?: string[]
  firstPairingName?: string
}

export interface MachineStateComputed extends MachineState {
  computed: ComputedData
}
